import {Card} from '@/components/Card'
import {CurrentPricingChart} from '../../charts/CurrentPricingChart'

export type Data = {
  label: string
  amount: number,
  earnings: number|null
  vat: number|null
}

type Props = {
  data: Data[]
}

const CurrentPricingCard: React.FC<Props> = ({data}) => {
  return (
    <Card
      title="Current pricing"
      collapsable={false}
    >
      <CurrentPricingChart data={data} />
    </Card>
  )
}

export {CurrentPricingCard}
